import './hero.scss';

export default () => {
};
